import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown, MessageCircleQuestion } from "lucide-react";
import styles from "../sidequest.module.scss";

const faqs = [
  {
    question: "Who can pre-register?",
    answer: "This program is reserved for developers who are part of the Sidequest program.",
  },
  {
    question: "How long does verification take?",
    answer: "Our team typically reviews requests within a few business days of submission.",
  },
  {
    question: "What happens after I'm approved?",
    answer: "You'll be notified once your details are verified, and your account will be granted access to your plan.",
  },
  {
    question: "Do I need to create an account first?",
    answer: "No. Just submit this form. Account access is set up for you once your details are verified.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.faqSplit}>
          <motion.div
            className={styles.faqSide}
            initial={{ opacity: 0, x: -16 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <span className={styles.badge}>FAQ</span>
            <h2>Common questions</h2>
            <p>
              Can&apos;t find what you&apos;re looking for? Reach out and
              we&apos;ll get back to you directly.
            </p>
            <div className={styles.faqContactCard}>
              <div className={styles.faqContactIcon}>
                <MessageCircleQuestion size={20} color="#ff2f6d" />
              </div>
              <div>
                <p style={{ color: "#fff", fontWeight: 600, fontSize: "14px", marginBottom: "2px" }}>
                  Still have questions?
                </p>
                <a href="mailto:partnerships@keyquest.io" style={{ fontSize: "13px" }}>
                  partnerships@keyquest.io
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className={styles.faqList}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            {faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={faq.question} className={styles.faqItem}>
                  <button
                    type="button"
                    className={`${styles.faqQuestion} ${isOpen ? styles.faqQuestionOpen : ""}`}
                    onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                    aria-expanded={isOpen}
                  >
                    <span className={styles.faqQuestionText}>
                      <span className={styles.faqIndex}>{String(idx + 1).padStart(2, "0")}</span>
                      {faq.question}
                    </span>
                    <ChevronDown size={18} />
                  </button>
                  {isOpen && <p className={styles.faqAnswer}>{faq.answer}</p>}
                </div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
